import { render, staticRenderFns } from "./CommentsDynamic.vue?vue&type=template&id=0cdb7320&scoped=true"
import script from "./CommentsDynamic.vue?vue&type=script&lang=js"
export * from "./CommentsDynamic.vue?vue&type=script&lang=js"
import style0 from "./CommentsDynamic.vue?vue&type=style&index=0&id=0cdb7320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb7320",
  null
  
)

export default component.exports